import { Component } from '@angular/core';
import {GritProjectService} from "../../../services/grit/grit.project.service";
import {GritUserService} from "../../../services/grit/grit.user.service";
import {clone} from "lodash";
import {BsModalRef} from "ngx-bootstrap/modal";
import {UiBlockService} from "../../../services/ui-block.service";

@Component({
  selector: 'app-area-subscription',
  templateUrl: './subscription-list.component.html',
  styleUrls: ['./subscription-list.component.scss','../../../app.component.scss'],
  standalone: false
})
export class SubscriptionListComponent {

  subscriptionList : string[];

  constructor(
    protected gritUserService : GritUserService,
    public bsModalRef : BsModalRef,
    private uiBlock: UiBlockService,
    ) {
    this.subscriptionList = clone(gritUserService.profile.firsSubscribed);
  }

  toggleFir(fir: string){
    let index = this.subscriptionList.indexOf(fir)
    if (index != -1){
      this.subscriptionList.splice(index,1)
    } else{
      this.subscriptionList.push(fir)
    }
  }

  async save(){
    this.uiBlock.startBlock("Saving mailing lists...")
    this.gritUserService.profile.firsSubscribed = clone(this.subscriptionList);
    await this.gritUserService.updateProfileFirsSubscribed();
    this.uiBlock.stopBlock()

    this.bsModalRef.hide();
  }

  cancel(){
    this.bsModalRef.hide();
  }

  //Get subscription from api
  protected readonly GritProjectService = GritProjectService;
}
